export default {
  host: process.env.VUE_APP_API_HOST || "http://api.capvital",
  version: process.env.VUE_APP_API_VERSION || "v3",
  client: process.env.VUE_APP_CLIENT || "http://app.capvital",
  client_new: process.env.VUE_APP_CLIENT_NEW || "http://localhost:8080/",
  scope: process.env.VUE_APP_SCOPE || "full_access",
  client_id: process.env.VUE_APP_CLIENT_ID || "suh"
};
